import React, { useEffect, useState } from 'react';
import { PartyPopper, Sparkles } from 'lucide-react';
import { apiClient } from '../../api/client';

const CONFETTI = ['#F5831F', '#7B4FD8', '#EC4899', '#10B981', '#3B82F6', '#F59E0B'];

const PlanUnlockCelebration = () => {
  const [planName, setPlanName] = useState(null);

  useEffect(() => {
    apiClient.request('/api/users/me/plan-celebration')
      .then(d => { if (d?.plan_unlock_celebration) setPlanName(d.plan_unlock_celebration); })
      .catch(() => {});
  }, []);

  const dismiss = () => {
    setPlanName(null);
    apiClient.request('/api/users/me/ack-plan-celebration', { method: 'POST' }).catch(() => {});
  };

  if (!planName) return null;

  return (
    <div
      data-testid="plan-unlock-celebration"
      className="mb-6 relative overflow-hidden rounded-2xl p-5 sm:p-6 text-center"
      style={{
        background: 'linear-gradient(135deg, #F3E8FF 0%, #FCE7F3 45%, #FFF5EA 100%)',
        border: '1.5px solid #D8B4FE',
        boxShadow: '0 2px 10px rgba(123,79,216,0.14)',
      }}
    >
      {/* Confetti dots */}
      {CONFETTI.map((c, i) => (
        <span key={i} className="absolute rounded-full opacity-70" style={{
          width: 8 + (i % 3) * 4, height: 8 + (i % 3) * 4, backgroundColor: c,
          top: `${8 + (i * 13) % 70}%`, left: `${4 + (i * 17) % 92}%`,
        }} />
      ))}
      <div className="relative">
        <div className="mx-auto w-14 h-14 rounded-2xl bg-white/80 flex items-center justify-center shadow-sm mb-3">
          <PartyPopper size={28} className="text-purple-600" />
        </div>
        <h3 className="text-xl sm:text-2xl font-bold text-gray-900">
          Your family upgraded you to <span className="text-purple-700">{planName}</span>! 🎉
        </h3>
        <p className="text-sm text-gray-600 mt-2 max-w-xl mx-auto">
          Everything just unlocked — more AvAs to practise with, deeper challenges and more voice time. It&apos;s all yours, starting now.
        </p>
        <button
          onClick={dismiss}
          className="mt-4 inline-flex items-center gap-2 px-6 py-3 rounded-xl text-white font-semibold text-sm transition-all hover:shadow-lg"
          style={{ backgroundColor: '#7B4FD8' }}
          data-testid="plan-celebration-dismiss-btn"
        >
          <Sparkles size={16} /> Let&apos;s go!
        </button>
      </div>
    </div>
  );
};

export default PlanUnlockCelebration;
